import extend from 'underscore';

export default class Omniture {
    constructor(options) {
        extend(this, options);
    }

    //On search events omniture needs to refresh to get search term data
    static emitTrackingSearch(query) {
        window.fastco_s.prop14 = query;
        window.fastco_s.linkTrackVars = 'prop14eVar12events';
        window.fastco_s.linkTrackEvents = 'event1';
        window.fastco_s.eVar12 = window.fastco_s.prop14;
        window.fastco_s.events = 'event1';
        window.fastco_s.tl(this, 'o', 'Internal Search');
    }

    static incrementPage(pageNum) {
        window.fastco_s.prop13 = pageNum;
        window.fastco_s.t();
    }

    static trackNewPage(model) {
        if (window.fastco_s === undefined || model === undefined) {
            return;
        }
        window.fastco_s.events = model.events;
        window.fastco_s.server = model.fastco_s.server;
        window.fastco_s.channel = model.fastco_s.channel;
        window.fastco_s.pageURL = window.location.pathname.href;
        window.fastco_s.pageName = model.fastco_s.pageName || '';
        window.fastco_s.pageType = model.fastco_s.pageType || '';
        window.fastco_s.eVar12 = "";
        if (model.fastco_s && model.fastco_s.props) {
            model.fastco_s.props.forEach(function forEachProps(item, index) {
                window.fastco_s['prop' + index] = item;
            });
        }
        window.fastco_s.t();
    }
}
